import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'


Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['auth/loggedIn']) {
                    next({ name: 'app' })
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/',
        component: () => import('../views/MainLayout'),
        redirect: '/home',
        name: 'Home',
        meta: {
            authRequired: true,
        },
        children: [
            {
                path: '/home',
                name: 'dashboard',
                component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/clients/add',
                name: 'AddClient',
                component: () => import(/* webpackChunkName: "addClient" */ '../views/clients/AddClient.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/clients/manage',
                name: 'Clients',
                component: () => import(/* webpackChunkName: "clients" */ '../views/clients/Clients.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/clients/groups',
                name: 'ClientsGroup',
                component: () => import(/* webpackChunkName: "clientsGroup" */ '../views/clients/ClientsGroups.vue'),
                meta: {
                    authRequired: true
                }
            },
            {
                path: '/employees/manage',
                name: 'Employees',
                component: () => import(/* webpackChunkName: "employees" */ '../views/employees/Employees.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/taxes',
                name: 'Taxes',
                component: () => import(/* webpackChunkName: "taxes" */ '../views/taxes/Taxes.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/discounts',
                name: 'Discounts',
                component: () => import(/* webpackChunkName: "taxes" */ '../views/discounts/Discounts.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/services',
                name: 'Services',
                component: () => import(/* webpackChunkName: "services" */ '../views/services/Services.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/servicesGroups',
                name: 'ServicesGroups',
                component: () => import(/* webpackChunkName: "servicesGroups" */ '../views/services/ServicesGroups.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/readyvisits',
                name: 'ReadyVisits',
                component: () => import(/* webpackChunkName: "readyvisits" */ '../views/services/ReadyVisits.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/readysets',
                name: 'ReadySets',
                component: () => import(/* webpackChunkName: "readySets" */ '../views/services/ReadySets.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/serviceplaces',
                name: 'ServicePlaces',
                component: () => import(/* webpackChunkName: "servicePlaces" */ '../views/servicePlaces/ServicePlaces.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/products',
                name: 'Products',
                component: () => import(/* webpackChunkName: "products" */ '../views/products/Products.vue'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/expenses',
                name: 'Expenses',
                component: () => import(/* webpackChunkName: "expenses" */ '../views/expenses/Expenses'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/appointments/schedule',
                name: 'Schedule',
                component: () => import(/* webpackChunkName: "schedule" */ '../views/bookings/Schedule'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/appointments/myschedule?provider=true',
                name: 'MySchedule',
                props: true,
                component: () => import(/* webpackChunkName: "schedule" */ '../views/bookings/Schedule'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/invoices',
                name: 'Invoices',
                component: () => import(/* webpackChunkName: "invoices" */ '../views/invoices/Invoices'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/cashier',
                name: 'Cashier',
                component: () => import(/* webpackChunkName: "cashier" */ '../views/invoices/Cashier'),
                meta: {
                    authRequired: true
                }
            },
            {
                path: '/creditnotes',
                name: 'CreditNotes',
                props: { type: 'ref' },
                component: () => import(/* webpackChunkName: "creditNotes" */ '../views/invoices/CreditNotes'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/adjustmentnotes',
                name: 'AdjustmentNotes',
                props: { type: 'adj' },
                component: () => import(/* webpackChunkName: "creditNotes" */ '../views/invoices/CreditNotes'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/invoices/nonbilled',
                name: 'NonbilledServices',
                component: () => import(/* webpackChunkName: "nonbilledServices" */ '../views/invoices/NonbilledServices'),
                meta: {
                    authRequired: true
                }
            },
            {
                path: '/users',
                name: 'Users',
                component: () => import(/* webpackChunkName: "users" */ '../views/users/Users'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/visittypes',
                name: 'VisitTypes',
                component: () => import(/* webpackChunkName: "visitTypes" */ '../views/bookings/VisitTypes'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/pricelists',
                name: 'PricesLists',
                component: () => import(/* webpackChunkName: "priceLists" */ '../views/priceLists/PriceLists'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/pricelists/editor',
                props: true,
                name: 'PricesListEditor',
                component: () => import(/* webpackChunkName: "pricesListEditor" */ '../views/priceLists/PriceListEditor'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/reports/financialmovement',
                name: 'FinancialMovement',
                component: () => import(/* webpackChunkName: "financialmovement" */ '../views/reports/FinancialMovement'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/reports',
                name: 'Reports',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/Reports'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: '/sponsers',
                name: 'Sponsers',
                component: () => import(/* webpackChunkName: "sponsers" */ '../views/sponsers/Sponsers'),
                meta: {
                    authRequired: true
                }
            },
            {
                path: '/insurance',
                name: 'Insurance',
                component: () => import(/* webpackChunkName: "insurance" */ '../views/insurance/Insurance'),
                meta: {
                    authRequired: true
                }
            },
            {
                path: '/datamonitor',
                name: 'DataMonitor',
                component: () => import(/* webpackChunkName: "datamonitor" */ '../views/monitor/Monitor'),
                meta: {
                    authRequired: true
                }
            }
        ]
    }
]

const router = new VueRouter({
    routes
})



router.beforeEach((routeTo, routeFrom, next) => {
    // If this isn't an initial page load...
    if (routeFrom.name !== null) {
        // Start the route progress bar.
        //store.dispatch('ui/setIsBusy');
    }

    // Check if auth is required on this route
    // (including nested routes).
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

    if (!authRequired) return next()

    if (store.getters['auth/loggedIn']) {
        //return next();
        // Validate the local user token...
        //return store.dispatch('auth/validate').then((validUser) => {
        //    console.log(validUser);
        // Then continue if the token still represents a valid user,
        // otherwise redirect to login.
        //    validUser ? next() : redirectToLogin()
        //})
        return next();
    } else {
        // If auth is required and the user is NOT currently logged in,
        // redirect to login.
        redirectToLogin()
    }


    function redirectToLogin() {
        // Pass the original route to the login component
        next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
    }
})





export default router
